import Header from './Header';
import { Outlet } from 'react-router-dom';
import DepositModal from '@/widget/DepositModal';
import WithdrawModal from '@/widget/WithdrawModal';
import InitStateContext from '@/context/initStateContext';
import ScrollToTop from '@/widget/ScrollToTop';

export default function Index() {
  return (
    <InitStateContext>
      <Header />
      <Outlet />
      <DepositModal />
      <WithdrawModal />
      <ScrollToTop />
    </InitStateContext>
  );
}
